import Cookies from 'js-cookie';

// Hooks
//
const toggleHook = "[js-navigation-toggle]";
const multiHook = "[js-menu-multi]";
const multiIconHook = "[js-menu-multi-icon]";
const loginHook = "[js-navigation-login]";
const registerHook = "[js-navigation-register]";
const registerLabelHook = "[js-navigation-register-label]";
const welcomeHook = "[js-navigation-welcome]";

// Classes
//
const activeClass = "navigation--is-open";
const activeMenuClass = "navigation__menu-list-item--active";
const noScrollClass = "u-no-scroll--mobile";

class Nav {
  constructor(element) {
    this.element = element;
    this.active = false;
    this.toggle = element.querySelector(toggleHook);
    this.multi = element.querySelectorAll(multiHook);
    this.lastScroll = 0;
    this.login = element.querySelectorAll(loginHook);
    this.register = element.querySelectorAll(registerHook);
    this.registerLabel = element.querySelectorAll(registerLabelHook);
    this.welcome = element.querySelectorAll(welcomeHook);
    this.userName = '';

    this.init();
  }

  init() {
    const body = document.body;
    const scrollDown = "navigation--down";
    const scrollUp = "navigation--up";

    window.addEventListener("scroll", () => {
      const currentScroll = window.pageYOffset;

      if (currentScroll <= 150) {
        body.classList.remove(scrollUp);
        return;
      }

      if (
        currentScroll > this.lastScroll &&
        !this.element.classList.contains(scrollDown)
      ) {
        this.element.classList.remove(scrollUp);
        this.element.classList.add(scrollDown);
      } else if (
        currentScroll < this.lastScroll &&
        this.element.classList.contains(scrollDown)
      ) {
        this.element.classList.remove(scrollDown);
        this.element.classList.add(scrollUp);
      }

      this.lastScroll = currentScroll;
    });

    this.toggle.addEventListener("click", () => {
      this.element.classList[!this.active ? "add" : "remove"](activeClass);
      document.body.classList[!this.active ? "add" : "remove"](noScrollClass);
      this.active = !this.active;
    });

    this.multi?.forEach((element) => {
      element.querySelector(multiIconHook)?.addEventListener("click", (e) => {
        e.preventDefault();
        element.classList[
          element.classList.contains(activeMenuClass) ? "remove" : "add"
        ](activeMenuClass);
      });
    });

    this.readCookies();
  }

  readCookies() {
    const userName = Cookies.get('user.name');

    if (userName) {
      this.userName = userName;

      this.welcome.forEach(e => {
        e.innerHTML = "Welkom, " + userName
        e.classList.add('active')
      });
      this.registerLabel.forEach(e => e.innerHTML = "Dashboard");
      this.register.href = "https://account.doijerkalff.nl/dashboard"
    } else {
      this.login.forEach(e => e.classList.add('active'))
    }

  }
}

export default Nav;
